module.exports = __webpack_public_path__ + "static/media/_special2.ca7fb753.jpg";